import React from 'react';
import { CalendarIcon, ClockIcon } from 'components/icons';
import { JobsiteAnnouncement } from 'apollo/generated/client-operations';
import { getPrettyFormattedDateTimeWithTz } from 'utils/dates';
import { AnnouncementSection } from './AnnouncementSection';
import { SplitCol } from './SplitCol';
import { AttributeDescription } from './AttributeDescription';
import { AnnouncementSentBy } from './AnnouncementSentBy';
import { AnnouncementStatusBadge } from './AnnouncementStatusBadge';

export function AnnouncementSummary({
  announcement,
}: {
  announcement: Partial<JobsiteAnnouncement>;
}): React.ReactElement {
  const { sentAt, startAt, timeZone } = announcement;
  return (
    <AnnouncementSection id="summary" title="Summary">
      <SplitCol>
        <AttributeDescription label="Subject" value={announcement.subject} />
        <AttributeDescription label="Message" value={announcement.message} />
      </SplitCol>

      <SplitCol>
        <AttributeDescription
          label="Scheduled"
          icon={CalendarIcon}
          value={
            startAt
              ? getPrettyFormattedDateTimeWithTz(startAt, timeZone)
              : 'Immediate'
          }
        />
        <AttributeDescription
          label="Sent"
          icon={ClockIcon}
          value={
            sentAt
              ? getPrettyFormattedDateTimeWithTz(sentAt, timeZone)
              : 'Not yet'
          }
        />
      </SplitCol>

      <SplitCol>
        {announcement?.sentBy ? (
          <AttributeDescription
            label="Sent By"
            value={<AnnouncementSentBy announcement={announcement} />}
          />
        ) : (
          <div />
        )}
        <AttributeDescription
          label="Status"
          value={<AnnouncementStatusBadge announcement={announcement} />}
        />
      </SplitCol>
    </AnnouncementSection>
  );
}
